import Vue from 'vue'
import Vuex from 'vuex'
import {loading} from '@/modules/loading/loading'
import {alert} from '@/modules/alert/alert';
import {company} from '@/modules/company/company'
import {user} from '@/modules/user/user'
import {agent} from '@/modules/agent/agent'
import {customer} from "@/modules/customers/customer";
import {country} from "@/modules/country/country";
import {item} from "@/modules/item/item";
import {product} from "@/modules/product/product";
import {bom} from "@/modules/bom/bom";
import {bom_subassembly} from "@/modules/bom_subassembly/bom_subassembly";
import {purchase} from '@/modules/purchase/purchase'
import {sale} from '@/modules/sale/sale'
import {subassembly} from "@/modules/subassembly/subassembly"
import {agreement} from '@/modules/agreement/agreement'
import {hs_code} from '@/modules/hs_code/hs_code'
import { product_specific_rule } from '@/modules/product_specific_rule/product_specific_rule';
import { product_specific_rule_exceptions } from '@/modules/product_specific_rule_exceptions/product_specific_rule_exceptions';
import { net_cost } from '@/modules/net_cost/net_cost';
import { supplier } from '@/modules/suppliers/supplier';
import { material_declaration } from '@/modules/material_declaration/material_declaration';
import { material_declaration_transaction } from '@/modules/material_declaration_transaction/material_declaration_transaction';
import {product_determination} from "@/modules/product_determination/product_determination";
import {product_determination_error} from "@/modules/product_determination_error/product_determination_error"
import {fta_bill_of_materials} from "@/modules/fta_bill_of_materials/fta_bill_of_materials";
import {origin_determination_filter} from "@/modules/origin_determination_filters/origin_determination_filter";
import {origin_determination} from "@/modules/origin_determination/origin_determination";
import {certificate_of_origin} from "@/modules/certificate_of_origin/certificate_of_origin"
import {erp_interface} from "@/modules/interfaces/interfaces";
import {reset_password_email} from "@/modules/reset_password_email/reset_password_email"
import {hs_code_associations} from "@/modules/hs_code_association/hs_code";
import {product_material_association} from "@/modules/product_material_association/product_material_association";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: '1.0.0', // a simple property
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    loading,
    alert,
    company,
    user,
    agent,
    customer,
    country,
    item,
    product,
    bom,
    bom_subassembly,
    purchase,
    sale,
    subassembly,
    agreement,
    hs_code,
    product_specific_rule,
    product_specific_rule_exceptions,
    net_cost,
    supplier,
    material_declaration,
    material_declaration_transaction,
    product_determination,
    product_determination_error,
    fta_bill_of_materials,
    origin_determination_filter,
    origin_determination,
    certificate_of_origin,
    erp_interface,
    reset_password_email,
    hs_code_associations,
    product_material_association
  }
})
